import { RequestService } from '../../../../common/services/RequestService';
import { CREATE_VEHICLE } from '../constants';
import {
  dataAdjustmentCardResponse,
  dataUpdateVehicleRequest
} from './dataAdjustment';

export const createVehicleRequest = async (profileId, data) => {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  };

  let formData = new FormData();
  const adjustedData = dataUpdateVehicleRequest(data);
  const keys = Object.keys(adjustedData['vehicle']);

  keys.forEach(key => {
    formData.append('vehicle[' + key + ']', adjustedData['vehicle'][key]);
  });

  const response = await RequestService.post(
    CREATE_VEHICLE.replace('{profile_id}', profileId),
    formData,
    config
  );

  return dataAdjustmentCardResponse(response.data);
};
